<div class="gridListdemoDynamicTiles" fxFlex>

  <span>
    @if (title) {
      <span>{{title}}</span>
    }
    @if (title && cardData.SubHeader) {
      <span> &bull; </span>
    }
    @if (cardData.SubHeader) {
      <span>{{cardData.SubHeader}}</span>
    }
    @if (cardData.SubHeader && cardData.Description) {
      <span> &bull; </span>
    }
    @if (cardData.Description) {
      <span> {{cardData.Description}}</span>
    }
  </span>

  <div fxLayout="row" layout-wrap>
    @if (portrait && hasPhoto) {
      <forge-avatar [image-url]="photoUrl">
      </forge-avatar>
    }

    @if (portrait && !hasPhoto) {
      <forge-avatar class="noPhoto">
        <forge-icon aria-hidden="true" name="person"></forge-icon>
      </forge-avatar>
    }

    @for (dataElement of elementsToShow; track dataElement) {
      <div fxFlex>
        @if (isCurrency(dataElement)) {
          <labeled-field [label]="dataElement.Label">
            <truncate-text [mainText]="dataElement.Value | currency" [multiLine]="false">
            </truncate-text>
          </labeled-field>
        }
        @if (hasIcon(dataElement)) {
          <labeled-field [label]="dataElement.Label" fxLayout="row">
            @if (!usesIconSpan(dataElement.Icon)) {
              <mat-icon>
                {{dataElement.Icon}}
              </mat-icon>
            }
            @if (usesIconSpan(dataElement.Icon)) {
              <span class="tt-icon" [ngClass]="getIconSpanClass(dataElement)">
              </span>
            }
            <span>{{dataElement.Value}}</span>
          </labeled-field>
        }
        @if (showLink(dataElement, true)) {
          <labeled-field [label]="dataElement.Label">
            <a (click)="openTypeCommand(dataElement)" class="tt-value-link"
              attr.telemetry="Submission-{{dataElement.Value}}">
              {{dataElement.Value}}
            </a>
          </labeled-field>
        }
        @if (showLink(dataElement, false, true)) {
          <labeled-field [label]="dataElement.Label">
            <a [href]="dataElement.ActionItems.ActionValue" class="tt-value-link">
              {{dataElement.Value}}
            </a>
          </labeled-field>
        }
        @if (showMetadataLink(dataElement)) {
          <labeled-field [label]="dataElement.Label">
            <a (click)="performMetadataAction(dataElement.ActionItems)" class="tt-value-link"
              attr.aria-label="Action-{{dataElement.Value}}">
              {{dataElement.Value}}
            </a>
          </labeled-field>
        }
        @if (showField(dataElement)) {
          <labeled-field [label]="dataElement.Label">
            <truncate-text [mainText]="dataElement.Value" [allowHtml]="true" [multiLine]="true">
            </truncate-text>
          </labeled-field>
        }
      </div>
    }
  </div>

  <div fxLayout="row wrap">
    <div style="width: 50px"></div>

    @for (dataElement of emailElements; track dataElement) {
      <div fxFlex>
        <labeled-field [label]="dataElement.Label">
          <a href="mailto:{{dataElement.Value}}">
            {{dataElement.Value}}
          </a>
        </labeled-field>
      </div>
    }
  </div>

  @if (chartConfig) {
    <div class="mt10">
      <chartjs-container [config]="chartConfig" [heightPx]="80">
      </chartjs-container>
    </div>
  }

  @if (hasCardActions) {
    <div fxLayout="row" fxLayoutAlign="end center">
      @for (action of cardData.CardActions; track action) {
        <div>
          @if (isIconButton(action)) {
            <forge-icon-button [disabled]="isProcessing"
              (click)="cardActionClicked(action)" [attr.aria-label]="getCardActionAriaLabel(action)"
              [attr.telemetry]="getCardActionTelemetryLabel(action)">
              <forge-tooltip placement="bottom">{{action.label}}</forge-tooltip>
              <forge-icon name="{{action.icon}}" [ngStyle]="getIconStyle(action.color)">
              </forge-icon>
            </forge-icon-button>
          }
          @if (isTextButton(action)) {
            <forge-button [disabled]="isProcessing" (click)="cardActionClicked(action)"
              [attr.telemetry]="getCardActionTelemetryLabel(action)">
              {{action.label}}
            </forge-button>
          }
          @if (isBadgeButton(action)) {
            <forge-icon-button (click)="cardActionClicked(action)"
              [disabled]="isProcessing">
              <forge-tooltip placement="bottom">
                {{action.label}}
              </forge-tooltip>
              @if (action.Model > 0) {
                <forge-badge positioned strong>
                  {{action.Model}}
                </forge-badge>
              }
              <forge-icon [name]="action.icon">
              </forge-icon>
            </forge-icon-button>
          }
        </div>
      }
    </div>
  }

  @if (isProcessing) {
    <forge-linear-progress></forge-linear-progress>
  }
</div>
